// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddContactToViewData, AddContactToViewResponses, ArchiveViewsData, ArchiveViewsResponses, BuyViewPhoneNumberData, BuyViewPhoneNumberResponses, CompanyRegistrySearchData, CompanyRegistrySearchResponses, CountContactsData, CountContactsResponses, CreateCompanyData, CreateCompanyResponses, CreateContactData, CreateContactResponses, CreateHolidayData, CreateHolidayResponses, CreatePublishedReviewData, CreatePublishedReviewResponses, CreateReviewInvitationData, CreateReviewInvitationResponses, DeleteHolidayData, DeleteHolidayResponses, DeleteProofData, DeleteProofResponses, GetCertificateData, GetCertificateResponses, GetCityData, GetCityResponses, GetCompanyData, GetCompanyResponses, GetContactData, GetContactResponses, GetLegalFormsData, GetLegalFormsResponses, GetNetworkData, GetNetworkResponses, GetPhoneNumberStatusData, GetPhoneNumberStatusResponses, GetProofData, GetProofResponses, GetSolicitationData, GetSolicitationResponses, GetViewData, GetViewResponses, ImportSubscriptionsFromZohoData, ImportSubscriptionsFromZohoResponses, ListContactsData, ListContactsResponses, ListHolidaysData, ListHolidaysResponses, ListReviewsData, ListReviewsResponses, ListViewsData, ListViewsResponses, PublishReviewData, PublishReviewResponses, RefuseReviewData, RefuseReviewResponses, ReplacePhoneNumberData, ReplacePhoneNumberResponses, SpamReviewData, SpamReviewResponses, SubmitProofData, SubmitProofResponses, SyncAllCompaniesWithPennylaneData, SyncAllCompaniesWithPennylaneResponses, SyncCompanyWithPennylaneData, SyncCompanyWithPennylaneResponses, SyncSpatialReviewsData, SyncSpatialReviewsResponses, UpdateCompanyData, UpdateCompanyResponses, UpdateContactData, UpdateContactResponses, UpdateHolidayData, UpdateHolidayResponses, UpdatePresentationData, UpdatePresentationResponses, UpdateReviewPresentationsData, UpdateReviewPresentationsResponses, UpdateViewData, UpdateViewResponses, ValidateProofData, ValidateProofResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get a solicitation by id
 */
export const getSolicitation = <ThrowOnError extends boolean = false>(options: Options<GetSolicitationData, ThrowOnError>) => (options.client ?? client).get<GetSolicitationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solicitations/{solicitationId}',
    ...options
});

/**
 * List views
 */
export const listViews = <ThrowOnError extends boolean = false>(options?: Options<ListViewsData, ThrowOnError>) => (options?.client ?? client).get<ListViewsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views',
    ...options
});

/**
 * Get a view
 */
export const getView = <ThrowOnError extends boolean = false>(options: Options<GetViewData, ThrowOnError>) => (options.client ?? client).get<GetViewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}',
    ...options
});

/**
 * Update a view
 */
export const updateView = <ThrowOnError extends boolean = false>(options: Options<UpdateViewData, ThrowOnError>) => (options.client ?? client).patch<UpdateViewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive views
 */
export const archiveViews = <ThrowOnError extends boolean = false>(options: Options<ArchiveViewsData, ThrowOnError>) => (options.client ?? client).post<ArchiveViewsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add a contact to a view
 */
export const addContactToView = <ThrowOnError extends boolean = false>(options: Options<AddContactToViewData, ThrowOnError>) => (options.client ?? client).post<AddContactToViewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/contacts/{contactId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Buy phone numbers for a view
 */
export const buyViewPhoneNumber = <ThrowOnError extends boolean = false>(options: Options<BuyViewPhoneNumberData, ThrowOnError>) => (options.client ?? client).post<BuyViewPhoneNumberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/phone-numbers/buy',
    ...options
});

/**
 * List holidays
 */
export const listHolidays = <ThrowOnError extends boolean = false>(options?: Options<ListHolidaysData, ThrowOnError>) => (options?.client ?? client).get<ListHolidaysResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/holidays',
    ...options
});

/**
 * Create a holiday
 */
export const createHoliday = <ThrowOnError extends boolean = false>(options: Options<CreateHolidayData, ThrowOnError>) => (options.client ?? client).post<CreateHolidayResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/holidays',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a holiday
 */
export const deleteHoliday = <ThrowOnError extends boolean = false>(options: Options<DeleteHolidayData, ThrowOnError>) => (options.client ?? client).delete<DeleteHolidayResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/holidays/{holidayId}',
    ...options
});

/**
 * Update a holiday
 */
export const updateHoliday = <ThrowOnError extends boolean = false>(options: Options<UpdateHolidayData, ThrowOnError>) => (options.client ?? client).patch<UpdateHolidayResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/holidays/{holidayId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List contacts
 */
export const listContacts = <ThrowOnError extends boolean = false>(options?: Options<ListContactsData, ThrowOnError>) => (options?.client ?? client).get<ListContactsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts',
    ...options
});

/**
 * Create a contact
 */
export const createContact = <ThrowOnError extends boolean = false>(options: Options<CreateContactData, ThrowOnError>) => (options.client ?? client).post<CreateContactResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Count contacts
 */
export const countContacts = <ThrowOnError extends boolean = false>(options?: Options<CountContactsData, ThrowOnError>) => (options?.client ?? client).get<CountContactsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/counts',
    ...options
});

/**
 * Get a contact
 */
export const getContact = <ThrowOnError extends boolean = false>(options: Options<GetContactData, ThrowOnError>) => (options.client ?? client).get<GetContactResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/{contactId}',
    ...options
});

/**
 * Update a contact
 */
export const updateContact = <ThrowOnError extends boolean = false>(options: Options<UpdateContactData, ThrowOnError>) => (options.client ?? client).patch<UpdateContactResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contacts/{contactId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update presentation
 */
export const updatePresentation = <ThrowOnError extends boolean = false>(options: Options<UpdatePresentationData, ThrowOnError>) => (options.client ?? client).patch<UpdatePresentationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/presentations/{presentationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace phone number
 */
export const replacePhoneNumber = <ThrowOnError extends boolean = false>(options: Options<ReplacePhoneNumberData, ThrowOnError>) => (options.client ?? client).post<ReplacePhoneNumberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/phone-numbers/{phoneNumberId}/replace',
    ...options
});

/**
 * Get phone number status
 */
export const getPhoneNumberStatus = <ThrowOnError extends boolean = false>(options: Options<GetPhoneNumberStatusData, ThrowOnError>) => (options.client ?? client).get<GetPhoneNumberStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/phone-numbers/{phoneNumberId}/status',
    ...options
});

/**
 * Get a network
 */
export const getNetwork = <ThrowOnError extends boolean = false>(options: Options<GetNetworkData, ThrowOnError>) => (options.client ?? client).get<GetNetworkResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/networks/{networkId}',
    ...options
});

/**
 * Get a city
 */
export const getCity = <ThrowOnError extends boolean = false>(options: Options<GetCityData, ThrowOnError>) => (options.client ?? client).get<GetCityResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cities/{cityId}',
    ...options
});

/**
 * List reviews
 */
export const listReviews = <ThrowOnError extends boolean = false>(options?: Options<ListReviewsData, ThrowOnError>) => (options?.client ?? client).get<ListReviewsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews',
    ...options
});

/**
 * Get the review certificate of a presentation
 */
export const getCertificate = <ThrowOnError extends boolean = false>(options: Options<GetCertificateData, ThrowOnError>) => (options.client ?? client).get<GetCertificateResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/certificate',
    ...options
});

/**
 * Create a directly published review
 */
export const createPublishedReview = <ThrowOnError extends boolean = false>(options: Options<CreatePublishedReviewData, ThrowOnError>) => (options.client ?? client).post<CreatePublishedReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish review
 */
export const publishReview = <ThrowOnError extends boolean = false>(options: Options<PublishReviewData, ThrowOnError>) => (options.client ?? client).post<PublishReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/publish',
    ...options
});

/**
 * Refuse review
 */
export const refuseReview = <ThrowOnError extends boolean = false>(options: Options<RefuseReviewData, ThrowOnError>) => (options.client ?? client).post<RefuseReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/refuse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Spam review
 */
export const spamReview = <ThrowOnError extends boolean = false>(options: Options<SpamReviewData, ThrowOnError>) => (options.client ?? client).post<SpamReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/spam',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the presentations a review is visible on: makes it visible on other presentations of
 * its company, removes it from some, or moves it
 */
export const updateReviewPresentations = <ThrowOnError extends boolean = false>(options: Options<UpdateReviewPresentationsData, ThrowOnError>) => (options.client ?? client).post<UpdateReviewPresentationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/presentations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a proof document
 */
export const deleteProof = <ThrowOnError extends boolean = false>(options: Options<DeleteProofData, ThrowOnError>) => (options.client ?? client).delete<DeleteProofResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/proof',
    ...options
});

/**
 * Get the proof document for a review.
 * Returns `null` when no proof has been submitted yet.
 */
export const getProof = <ThrowOnError extends boolean = false>(options: Options<GetProofData, ThrowOnError>) => (options.client ?? client).get<GetProofResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/proof',
    ...options
});

/**
 * Submit a proof document for a review
 */
export const submitProof = <ThrowOnError extends boolean = false>(options: Options<SubmitProofData, ThrowOnError>) => (options.client ?? client).post<SubmitProofResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/proof',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Validate a proof document
 */
export const validateProof = <ThrowOnError extends boolean = false>(options: Options<ValidateProofData, ThrowOnError>) => (options.client ?? client).post<ValidateProofResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewId}/proof/validate',
    ...options
});

/**
 * Synchronize spatial indexing for all reviews
 */
export const syncSpatialReviews = <ThrowOnError extends boolean = false>(options?: Options<SyncSpatialReviewsData, ThrowOnError>) => (options?.client ?? client).post<SyncSpatialReviewsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/sync-spatial',
    ...options
});

/**
 * Create a review invitation
 */
export const createReviewInvitation = <ThrowOnError extends boolean = false>(options: Options<CreateReviewInvitationData, ThrowOnError>) => (options.client ?? client).post<CreateReviewInvitationResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/review-invitations/{reviewInvitationId}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Temporary route for Pennylane migration
 */
export const syncAllCompaniesWithPennylane = <ThrowOnError extends boolean = false>(options?: Options<SyncAllCompaniesWithPennylaneData, ThrowOnError>) => (options?.client ?? client).post<SyncAllCompaniesWithPennylaneResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/sync-pennylane',
    ...options
});

/**
 * Temporary route for Pennylane migration
 */
export const syncCompanyWithPennylane = <ThrowOnError extends boolean = false>(options: Options<SyncCompanyWithPennylaneData, ThrowOnError>) => (options.client ?? client).post<SyncCompanyWithPennylaneResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/sync-pennylane',
    ...options
});

/**
 * Search companies in registry
 */
export const companyRegistrySearch = <ThrowOnError extends boolean = false>(options?: Options<CompanyRegistrySearchData, ThrowOnError>) => (options?.client ?? client).get<CompanyRegistrySearchResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/registry-search',
    ...options
});

/**
 * Get a company
 */
export const getCompany = <ThrowOnError extends boolean = false>(options: Options<GetCompanyData, ThrowOnError>) => (options.client ?? client).get<GetCompanyResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}',
    ...options
});

/**
 * Update a company
 */
export const updateCompany = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyData, ThrowOnError>) => (options.client ?? client).patch<UpdateCompanyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get legal form list
 */
export const getLegalForms = <ThrowOnError extends boolean = false>(options?: Options<GetLegalFormsData, ThrowOnError>) => (options?.client ?? client).get<GetLegalFormsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/legal-forms',
    ...options
});

/**
 * Create a company
 */
export const createCompany = <ThrowOnError extends boolean = false>(options: Options<CreateCompanyData, ThrowOnError>) => (options.client ?? client).post<CreateCompanyResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Temporary route for the Zoho migration: creates the subscriptions of the
 * views from their Zoho recurring invoices (active, expired and stopped),
 * exported by the zoho stack. Sent in batches by the admin.
 */
export const importSubscriptionsFromZoho = <ThrowOnError extends boolean = false>(options: Options<ImportSubscriptionsFromZohoData, ThrowOnError>) => (options.client ?? client).post<ImportSubscriptionsFromZohoResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/subscriptions/import-from-zoho',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
